import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { getUser2, getUserCommissionEarnings } from "../actions";
import { resolveErrorMessage } from "../util";
import ErrorMessage from "./components/ErrorMessage";
import EarningsReport from "./components/Reports/Earnings/EarningsReport";
import LoadingSpinner from "./components/LoadingSpinner";
import { getUserEarnings } from "../actions";

const EarningsReportAdminPage = ({ history, location, match }) => {
  const currentUser = useSelector((state) => state.user.user.me);
  const [user, setUser] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        if (user) return;
        setLoading(true);
        setError(null);
        const userFromLocation = location?.state?.customer;
        if (userFromLocation) {
          setUser(userFromLocation);
          return;
        }

        const id = match?.params?.id;
        const hasOnlyNumbers = /^[0-9]+$/;

        if (!id || !hasOnlyNumbers.test(id)) {
          throw new Error("app.user.notFound");
        }

        const userFromServer = await getUser2(id);
        setUser(userFromServer);
      } catch (e) {
        const errorMessage = resolveErrorMessage(e);
        setError(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [location, match, user]);

  const fetchContractEarnings = React.useCallback(
    async (params) => {
      if (!user?.id) return;
      return getUserEarnings(params, user.id);
    },
    [user],
  );

  const fetchCommissionsEarnings = React.useCallback(
    async (params) => {
      if (!user?.id) return;
      return getUserCommissionEarnings(params, user.id);
    },
    [user],
  );

  if (loading) {
    return <LoadingSpinner message={<FormattedMessage id="app.loading.fetching.user" />} />;
  }

  if (error) {
    return (
      <ErrorMessage>
        <FormattedMessage id={error} />{" "}
      </ErrorMessage>
    );
  }

  return (
    <EarningsReport
      history={history}
      user={user}
      currentUser={currentUser}
      match={match}
      getContractEarnings={fetchContractEarnings}
      getCommissionsEarnings={fetchCommissionsEarnings}
    />
  );
};
export default EarningsReportAdminPage;
